import Slides from '../slides/Slides'

const Accidente = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides="accidente"/>
         <div className="section animated fadeIn">
            <div className="row center container">
               <div className="col s12 m12 l12 x12">
                  <h4 className="light-blue-text text-accent-3 left-align">¿Qué hacer si me accidento?</h4>
                  <div className="left-align font-size-18 grey-text text-darken-1">
                     <blockquote>
                        <p><strong><em>Ante un accidente de trabajo o accidente in itinere, el trabajador debe informar el hecho ante su empleador, quien tiene la obligación de comunicar el accidente o enfermedad profesional a la <span className="black-text">ART</span>.</em></strong></p>
                     </blockquote>
                  </div>
               </div>
            </div>
            <div className="row center container">
               <div className="col s12 m12 l12 x12">
                  <h5 className="light-blue-text text-accent-3 left-align">Realizar la Denuncia por los medios de comunicación:</h5>
                  <div className="left-align font-size-18 grey-text text-darken-1">
                     <blockquote>
                        <p><strong><em>Centro Coordinador de Atención Permanente – CECAP 0 800 199 0022 | Todos los días 24 hs.</em></strong></p>
                     </blockquote>
                  </div>
                  <h5 className="light-blue-text text-accent-3 left-align">Jujuy</h5>
                  <div className="left-align font-size-18 grey-text text-darken-1">
                     <blockquote>
                        <p><strong><em>4911741 | lunes a viernes de 8 a 13 hs y de 14 a 17 hs.</em></strong></p>
                        <p><strong><em>0388 15 - 6867840 | Las 24 hs.</em></strong></p>
                        <p><strong><em>Personalmente en Urquiza 602, Ciudad Perico.</em></strong></p>
                     </blockquote>
                  </div>
                  <h5 className="light-blue-text text-accent-3 left-align">Ciudad de SALTA</h5>
                  <div className="left-align font-size-18 grey-text text-darken-1">
                     <blockquote>
                        <p><strong><em>0388 15 - 5088438 | lunes a viernes de 8 a 12 hs.</em></strong></p>
                     </blockquote>
                  </div>
                  <h5 className="light-blue-text text-accent-3 left-align">Las lajitas, Pcia. de Salta</h5>
                  <div className="left-align font-size-18 grey-text text-darken-1">
                     <blockquote>
                        <p><strong><em>0388 15 - 5207392 | lunes a viernes de 8 a 13 hs y de 14 a 17 hs.</em></strong></p>
                     </blockquote>
                  </div>
                  <h6 className="text-accent-3 left-align"><strong>Un representante de Latitud Sur</strong> le indicará el Centro de Salud que corresponda.</h6>
               </div>
            </div>
            <div className="row center container">
               <div className="col s12 m12 l12 x12">
                  <div className="left-align font-size-18 grey-text text-darken-1">
                     <blockquote>
                        <p><strong><em>El trabajador deberá completar el Formulario de Denuncia de Accidente.  <a href="descargas/siniestros/FormularioDeDenunciadeSiniestrosARTLatitudSurSA.pdf" title="Descargar Formulario" className="btn btn-floating waves-effect waves-light bg-latitud pulse" type="submit" name="action"><i className="material-icons right">cloud_download</i></a></em></strong></p>
                        <p><strong><em>Luego, remitirlo a <span className="black-text">art.denuncias@latitudsursa.com.ar</span> o enviarlo por fax al <span className="black-text">4911034</span>.</em></strong></p>
                        <p><strong><em>También puede presentar el formulario personalmente en: Urquiza 602, Ciudad Perico, Jujuy.</em></strong></p>
                        <p><strong><em>Latitud Sur debe enviar el formulario de denuncia de accidente a la Superintendencia de Riesgos del Trabajo, <span className="black-text">DENTRO DE LAS 48 HS.</span> de ocurrido el hecho.</em></strong></p>
                     </blockquote>
                  </div>
                  <h6 className="light-blue-text text-accent-3 left-align"><strong>Ante cualquier duda, por favor, comuníquese a nuestro Centro de Atención al Cliente 0 800 199 0023 los días hábiles de 8 a 13hs y de 14 a 17hs</strong></h6>
               </div>
            </div>
         </div>            
      </>
   )
}

export default Accidente